export const PROJECT_ITEM_MENU = 'project-item-menu'
export const PROJECT_ITEM_MENU_MOVE = 'select-move'
export const PROJECT_ITEM_MENU_DELETE = 'select-delete'
export const PROJECT_ITEM_MENU_EDIT = 'select-edit'
